"use client";
import React, { useState, useEffect } from "react";
import { usePathname } from "@/i18n/navigation";
import { sha256, sha224 } from "js-sha256";
import { FiCopy, handleCopy } from "../common/commonFunction/handleCopy";

function CryptoFormat() {
  const [text, setText] = useState("");
  const [convert, setConvert] = useState("");
  const [copy, setCopy] = useState(false);
  const [errors, setErrors] = useState("");

  const rot13Cipher = require("rot13-cipher");
  let rot47 = require("rot47");

  const Name = usePathname();

  useEffect(() => {
    setErrors("");
    setConvert("");
    setText("");
    setCopy(false);
  }, [Name]);

  const handleOnChange = (event) => {
    setErrors("");
    setText(event.target.value);
    setConvert("");
    setCopy(false);
  };

  const handleOnErase = () => {
    setText("");
    setCopy(false);
    setConvert("");
  };

  const handleOnClick = () => {
    if (!text || text.trim() === "") return setErrors("* Please enter text.");
    setConvert(rot13Cipher(text));
    setCopy(false);
  };

  const handleOnFoursevenClick = () => {
    if (!text || text.trim() === "") return setErrors("* Please enter text.");
    setConvert(rot47(text));
    setCopy(false);
  };

  return (
    <>
      {Name === "/rot-13-encode-data" && (
        <>
          <div className="main-globally-counter-box">
            {text?.length > 0 && (
              <div className="color-picker-icon">
                <i
                  className="fa-solid fa-eraser"
                  title="Clear"
                  onClick={handleOnErase}
                ></i>
              </div>
            )}
            <div className="counter-text-area">
              <textarea
                className={errors ? "error-input" : " "}
                placeholder="Enter your text here..."
                value={text}
                onChange={handleOnChange}
              />
              <span>{errors}</span>
            </div>
          </div>
          <div className="button lowercase-center-alignment-new">
            <button onClick={handleOnClick}>Generate Now</button>
          </div>
          {convert && (
            <div className="main-globally-counter-box">
              <div className="copy-textarea-icon-alignment">
                <FiCopy onClick={() => handleCopy(convert)} />
                {copy && (
                  <div>
                    <span>Copied</span>
                  </div>
                )}
              </div>
              <div className="counter-text-area">
                <textarea value={convert} disabled />
                <div className="new-copy-icon-text-style-alignment position-unset"></div>
              </div>
            </div>
          )}
        </>
      )}

      {/* rot-13-decode-data */}
      {Name === "/rot-13-decode-data" && (
        <>
          <div className="main-globally-counter-box">
            {text?.length > 0 && (
              <div className="color-picker-icon">
                <i
                  className="fa-solid fa-eraser"
                  title="Clear"
                  onClick={handleOnErase}
                ></i>
              </div>
            )}
            <div className="counter-text-area">
              <textarea
                className={errors && "error-input"}
                placeholder="Enter rot-13 text for decode"
                value={text}
                onChange={handleOnChange}
              />
              <span>{errors}</span>
            </div>
          </div>
          <div className="button lowercase-center-alignment-new">
            <button onClick={handleOnClick}>Generate Now</button>
          </div>
          {convert && (
            <div className="main-globally-counter-box">
              <div className="copy-textarea-icon-alignment">
                <FiCopy onClick={() => handleCopy(convert)} />
                {copy && (
                  <div>
                    <span>Copied</span>
                  </div>
                )}
              </div>
              <div className="counter-text-area">
                <textarea value={convert} disabled />
              </div>
            </div>
          )}
        </>
      )}

      {/* rot-47-encode-data */}
      {Name === "/rot-47-encode-data" && (
        <>
          <div className="main-globally-counter-box">
            {text?.length > 0 && (
              <div className="color-picker-icon">
                <i
                  className="fa-solid fa-eraser"
                  title="Clear"
                  onClick={handleOnErase}
                ></i>
              </div>
            )}
            <div className="counter-text-area">
              <textarea
                className={errors && "error-input"}
                placeholder="Enter your text here..."
                value={text}
                onChange={handleOnChange}
              />
              <span>{errors}</span>
            </div>
          </div>
          <div className="button lowercase-center-alignment-new">
            <button onClick={handleOnFoursevenClick}>Generate Now</button>
          </div>
          {convert && (
            <div className="main-globally-counter-box">
              <div className="copy-textarea-icon-alignment">
                <FiCopy onClick={() => handleCopy(convert)} />
                {copy && (
                  <div>
                    <span>Copied</span>
                  </div>
                )}
              </div>
              <div className="counter-text-area">
                <textarea value={convert} disabled />
                <div className="new-copy-icon-text-style-alignment position-unset"></div>
              </div>
            </div>
          )}
        </>
      )}

      {/* rot-47-decode-data */}
      {Name === "/rot-47-decode-data" && (
        <>
          <div className="main-globally-counter-box">
            {text?.length > 0 && (
              <div className="color-picker-icon">
                <i
                  className="fa-solid fa-eraser"
                  title="Clear"
                  onClick={handleOnErase}
                ></i>
              </div>
            )}
            <div className="counter-text-area">
              <textarea
                className={errors ? "error-input" : ""}
                placeholder="Enter rot-47 text for decode"
                value={text}
                onChange={handleOnChange}
              />
              <span>{errors}</span>
            </div>
          </div>
          <div className="button lowercase-center-alignment-new">
            <button onClick={handleOnFoursevenClick}>Generate Now</button>
          </div>
          {convert && (
            <div className="main-globally-counter-box">
              <div className="copy-textarea-icon-alignment">
                <FiCopy onClick={() => handleCopy(convert)} />
                {copy && (
                  <div>
                    <span>Copied</span>
                  </div>
                )}
              </div>
              <div className="counter-text-area">
                <textarea value={convert} disabled />
                <div className="new-copy-icon-text-style-alignment position-unset"></div>
              </div>
            </div>
          )}
        </>
      )}

      {/* sha224-hash-generator */}
      {Name === "/sha224-hash-generator" && (
        <>
          <div className="main-globally-counter-box">
            {text?.length > 0 && (
              <div className="color-picker-icon">
                <i
                  className="fa-solid fa-eraser"
                  title="Clear"
                  onClick={handleOnErase}
                ></i>
              </div>
            )}
            <div className="counter-text-area">
              <textarea
                className={errors && "error-input"}
                placeholder="Enter text here for encode"
                value={text}
                onChange={handleOnChange}
              />
              <span>{errors}</span>
            </div>
          </div>
          <div className="button lowercase-center-alignment-new">
            <button
              onClick={() => {
                setConvert(sha224(text));
                setCopy(false);
              }}
            >
              Genrate Now
            </button>
          </div>
          {convert && (
            <div className="main-globally-counter-box">
              <div className="copy-textarea-icon-alignment">
                <FiCopy onClick={() => handleCopy(convert)} />
                {copy && (
                  <div>
                    <span>Copied</span>
                  </div>
                )}
              </div>
              <div className="counter-text-area">
                <textarea value={convert} className="text-black" disabled />
                <div className="new-copy-icon-text-style-alignment position-unset"></div>
              </div>
            </div>
          )}
        </>
      )}

      {/* sha256-hash-generator */}
      {Name === "/sha256-hash-generator" && (
        <>
          <div className="main-globally-counter-box">
            {text?.length > 0 && (
              <div className="color-picker-icon">
                <i
                  className="fa-solid fa-eraser"
                  title="Clear"
                  onClick={handleOnErase}
                ></i>
              </div>
            )}
            <div className="counter-text-area">
              <textarea
                className={errors && "error-input"}
                placeholder="Enter text here for encode"
                value={text}
                onChange={handleOnChange}
              />
              <span>{errors}</span>
            </div>
          </div>
          <div className="button lowercase-center-alignment-new">
            <button
              onClick={() => {
                setConvert(sha256(text));
                setCopy(false);
              }}
            >
              Genrate Now
            </button>
          </div>
          {convert && (
            <div className="main-globally-counter-box">
              <div className="copy-textarea-icon-alignment">
                <FiCopy onClick={() => handleCopy(convert)} />
                {copy && (
                  <div>
                    <span>Copied</span>
                  </div>
                )}
              </div>
              <div className="counter-text-area">
                <textarea value={convert} className="text-black" disabled />
                <div className="new-copy-icon-text-style-alignment position-unset"></div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default CryptoFormat;
